import React from "react"
import { withRouter } from "react-router-dom"
import ReactSVG from "react-svg"

const DtTopBanner = () => {
  const requestService = () => {
    window.open(
      "https://survey.alchemer.com/s3/8630063/Discount-Tire-Fleet-Services-Mobile-Service-Inquiry",
      "_blank"
    )
  }

  return (
    <>
      <div className="w-full mt-5 hidden md:block">
        <ReactSVG
          src={`/images/dt-banner.svg`}
          className="cursor-pointer"
          onClick={requestService}
        />
      </div>
      <div className="w-full mt-5 block md:hidden">
        <ReactSVG
          src={`/images/dt-banner.svg`}
          className="cursor-pointer"
          onClick={requestService}
        />
      </div>
    </>
  )
}

export const DTBanner = withRouter(DtTopBanner)
